import { useEffect, useState } from "react";

const empty = {};
export default function useSharedAnalyses({ apiBaseUrl, token, enabled, webMeetingId, scopeKey = "team" }) {
  const scope = `${apiBaseUrl}|${webMeetingId || scopeKey}`;
  const [result, setResult] = useState(null);
  useEffect(() => {
    if (!enabled || !token) return;
    let stopped = false, fetching = false, timer, controller;
    async function poll() {
      if (stopped || fetching || document.hidden) return;
      fetching = true;
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const query = webMeetingId ? `?webMeetingId=${encodeURIComponent(webMeetingId)}` : "";
        const response = await fetch(`${apiBaseUrl.replace(/\/$/, "")}/api/remote-analysis/shared${query}`, {
          method: "GET", signal: controller.signal, cache: "no-store", headers: { Authorization: `Bearer ${token}` },
        });
        const value = await response.json().catch(() => ({}));
        if (!stopped) {
          const requests = response.ok && Array.isArray(value.requests) ? Object.fromEntries(value.requests
            .filter(item => /^[a-f0-9]{32}$/i.test(item.requestId) && Number.isInteger(item.targetUserId) && item.targetUserId > 0
              && ["Pending", "Approved", "Running"].includes(item.state))
            .map(item => [item.targetUserId, item])) : empty;
          setResult({ scope, token, requests });
        }
      } catch {
        // Active row polling marks delayed samples; discovery must never invent telemetry.
      } finally {
        clearTimeout(timeout); fetching = false;
        if (!stopped && !document.hidden) timer = setTimeout(poll, 5000);
      }
    }
    const visibility = () => {
      clearTimeout(timer);
      if (document.hidden) controller?.abort(); else poll();
    };
    document.addEventListener("visibilitychange", visibility);
    poll();
    return () => { stopped = true; clearTimeout(timer); controller?.abort(); document.removeEventListener("visibilitychange", visibility); };
  }, [apiBaseUrl, token, enabled, webMeetingId, scope]);
  return enabled && result?.scope === scope && result?.token === token ? result.requests : empty;
}
